import React, { useState, useEffect } from "react";
import firebase from "../../Firebase/firebase";
import "./../../assets/styles/custom/Maindash.scss";
import Footer from "../Layout/Footer";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { MainDashboardQuery } from "./Queries/MainDashoardQuery";
import { HoverProfileQuery } from "../HoverProfile/Queries/HoverProfileQuery";
import { Dashboards } from "../Dashboard/Crew/CrewDashboard/Queries/DashboardQuery";

import Loading from "./../../assets/images/loading.gif";
import Loading2 from "./../../assets/images/loading2.gif";

function MainDashboard() {
  const [users, setusers] = useState({});
  let history = useHistory();

  //new start
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        localStorage.setItem("token", token);
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else {
        history.push("/");
      }
    });
  }, []);
  //new end
  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        history.push("/");
        localStorage.clear();
      })
      .catch(function (error) {
        localStorage.clear();
        history.push("/");
      });
  };
  const { data: dataa } = useQuery(MainDashboardQuery, {
    variables: { id: users?.token?.claims?.user_id },
  });

  const { data: data1 } = useQuery(HoverProfileQuery, {
    variables: { id: users?.token?.claims?.user_id },
  });

  const { data: data2 } = useQuery(Dashboards, {
    variables: { id: users?.token?.claims?.user_id },
  });

  console.log(JSON.stringify(dataa) + "Upper");
  console.log(dataa?.aatmsv4_register[0]?.client);

  return (
    <React.Fragment>
      <div className="main-dash-container animate__animated animate__fadeIn">
        <div className="main-dash-top">
          <div className="right-container">
            <div className="right_header">{/* <Header /> */}</div>
            <div className="right_content">
              <div className="company-message-line" />
              <div className="company-message">
                {dataa?.aatmsv4_register?.length === 1 &&
                users?.token?.claims?.user_id ? (
                  dataa?.aatmsv4_register[0]?.client?.landingmessage
                ) : (
                  <img width="150px" src={Loading2} alt="" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="profile-card-container">
          <div className="top-container">
            <div className="profile-container">
              <img
                src={
                  dataa?.aatmsv4_register?.length === 1 &&
                  users?.token?.claims?.user_id
                    ? dataa?.aatmsv4_register[0]?.client?.logo
                    : Loading
                }
                alt="Profile"
                height="100%"
                width="100%"
              />
            </div>
            <div className="user-name">
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id ? (
                dataa?.aatmsv4_register[0]?.client?.clientname
              ) : (
                <img width="100px" src={Loading2} alt="" />
              )}
            </div>
            <div className="bottom-container">
              <div className="profile-items">
                <div className="logout-container">
                  {users?.token?.claims?.user_id &&

                  data1?.aatmsv4_register?.length === 1 &&
                  data1 ? (
                    data1?.aatmsv4_register[0]?.name
                  ) : (
                    <img width="100px" src={Loading2} alt="" />
                  )}

                </div>
                {/* <div className="text">
                  {dataa?.aatmsv4_register?.length === 1 &&
                  users?.token?.claims?.user_id ? (
                    dataa?.aatmsv4_register[0]?.client?.department
                  ) : (
                    <img width="100px" src={Loading2} alt="" />
                  )}
                </div> */}
                <div className="title">
                  {users?.token?.claims?.user_id ? (
                    data2?.aatmsv4_crews[0]?.fleet?.aircraft
                  ) : (
                    <img width="100px" src={Loading2} alt="" />
                  )}
                </div>
              </div>
            </div>                                 
                   <div className="logout-container" onClick={logout}>
              <div className="fa fa-power-off" />
              Logout
            </div>
          </div>
        </div>
        <div className="main-dash-bottom">
          <div className="right-container">
            <div className="main-title">
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id ? (
                "Select your role to login"
              ) : (
                <img width="150px" src={Loading2} alt="" />
              )}
            </div>
            <div className="roles-item-container">
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id &&
              dataa?.aatmsv4_register[0]?.crew ? (
                <Link to="/dashboard/crew" className="roles-items">
                  <div className="crew"></div>
                  <div className="title">Crew</div>
                </Link>
              ) : null}
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id &&
              dataa?.aatmsv4_register[0]?.aircraft ? (
                <Link to="/dashboard/aircraft" className="roles-items">
                  <div className="aircraft"></div>
                  <div className="title">Aircraft</div>
                </Link>
              ) : null}
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id &&
              dataa?.aatmsv4_register[0]?.simulator ? (
                <Link to="/dashboard/simulator" className="roles-items">
                  <div className="simulator"></div>
                  <div className="title">Simulator</div>
                </Link>
              ) : null}
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id &&
              dataa?.aatmsv4_register[0]?.ground ? (
                <Link to="/dashboard/ground" className="roles-items">
                  <div className="ground"></div>
                  <div className="title">Ground</div>
                </Link>
              ) : null}
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id &&
              dataa?.aatmsv4_register[0]?.managers ? (
                <Link to="/dashboard/manager" className="roles-items">
                  <div className="manager"></div>
                  <div className="title">Manager</div>
                </Link>
              ) : null}
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id &&
              dataa?.aatmsv4_register[0]?.optimiser ? (
                <div className="roles-items">
                  <div className="optimiser"></div>
                  <div className="title">Optimiser</div>
                </div>
              ) : null}
              {dataa?.aatmsv4_register?.length === 1 &&
              users?.token?.claims?.user_id &&
              dataa?.aatmsv4_register[0]?.dataadmin ? (
                <Link to="/dashboard/data-admin" className="roles-items">
                  <div className="data-admin"></div>
                  <div className="title">Data Admin</div>
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default MainDashboard;
